<style src="css/serviceAssistant.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <div class="fixedBox">
            <div class="fixedTopBox">
                <div class="backIcon"></div>
                <div class="back" @click="back"></div>
                <!--                <div class="topTitle">{{chatDoctor.doctorName}}</div>-->
                <div class="topTitle">服务助手</div>
                <div class="rule" @click="clearAllNoReadForUser">清除未读</div>
            </div>
        </div>
        <ul>
            <li v-for="item in systemMessageList">
                <div class="topBox" :class="{active:item.readed}">
                    {{item.type | isType}} <span  :class="{active:item.readed}">{{item.createTime | time}}</span>
                </div>
                <div class="content"  :class="{active:item.readed}">{{item.content}}</div>
                <div class="bottomBox"  :class="{active:item.readed}" @click="to(`serviceAssistantDetail?messageId=${item.messageId}`)">
                    查看详情 <span></span>
                </div>
            </li>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </ul>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageSize: 10,
                pageIndex: 1,
                count: 0,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                systemMessageList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {
            isType(value){
                let arr = ['访问主页','预约咨询','开始咨询','结束咨询','取消咨询']
                return arr[value]
            },
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            back(){
                history.back()
            },
            async getSystemMessageListForUser() {
                let data = await getSources("/bear-scale/api/systemMessage/getSystemMessageListForUser.json", {
                    userId: localStorage.getItem('userId'),
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                });
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.systemMessageList = [...this.systemMessageList, ...data.systemMessageList];
                    if (data.systemMessageList.length == 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }
                }else{
                    alert(data.msg)
                }
            },
            async clearAllNoReadForUser() {
                let data = await getSources("/bear-scale/api/systemMessage/clearAllNoReadForUser.json", {
                    userId: localStorage.getItem('userId')
                });
                if (data.status === 0) {
                    this.pageIndex=1;
                    this.systemMessageList=[];
                    this.getSystemMessageListForUser()
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getSystemMessageListForUser()
                    }
                }
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getSystemMessageListForUser()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/serviceAssistant.vue?37438cc2